import { Box, CircularProgress } from "@mui/material";

export const InitiatePaymentKeypadSkeleton = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    height="620px"
  >
    <CircularProgress sx={{ color: "grey.300" }} />
  </Box>
);
